export default __webpack_public_path__ + "static/media/services_website_development_blur.7031af48.png";